import { i as _slicedToArray, c as _objectWithoutProperties, d as _objectSpread2 } from './_rollupPluginBabelHelpers.js';
import { createContext, useState, useEffect, forwardRef, useMemo, useContext } from 'react';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { PopupTargetContext, PopupTarget } from '../popup/popup.target.js';
import { getPopupContainer } from '../popup/popup.js';
import getUID from '../global/get-uid.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var modules_6381a4b3 = {"light":"light_rui_2ac4"};

var modules_59717246 = {"dark":"dark_rui_f090"};

var _excluded = ["theme", "className", "passToPopups", "children", "target"];
var Theme;
(function (Theme) {
  Theme["AUTO"] = "auto";
  Theme["LIGHT"] = "light";
  Theme["DARK"] = "dark";
})(Theme || (Theme = {}));
var ThemeContext = /*#__PURE__*/createContext({
  theme: Theme.LIGHT
});
var GLOBAL_DARK_CLASS_NAME = 'ring-ui-theme-dark';
var darkMatcher = window.matchMedia('(prefers-color-scheme: dark)');
function useTheme() {
  var _useState = useState(darkMatcher.matches),
    _useState2 = _slicedToArray(_useState, 2),
    dark = _useState2[0],
    setDark = _useState2[1];
  useEffect(function () {
    var onChange = function onChange(e) {
      return setDark(e.matches);
    };
    darkMatcher.addEventListener('change', onChange);
    return function () {
      return darkMatcher.removeEventListener('change', onChange);
    };
  }, []);
  return dark ? Theme.DARK : Theme.LIGHT;
}
function useThemeClasses(theme) {
  var systemTheme = useTheme();
  var resolvedTheme = theme === Theme.AUTO ? systemTheme : theme;
  return classNames({
    [modules_59717246.dark]: resolvedTheme === Theme.DARK,
    [GLOBAL_DARK_CLASS_NAME]: resolvedTheme === Theme.DARK,
    [modules_6381a4b3.light]: resolvedTheme === Theme.LIGHT
  });
}
function WithThemeClasses(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  var themeClasses = useThemeClasses(theme);
  return children(themeClasses);
}
function applyTheme(theme, container) {
  if (theme === Theme.DARK) {
    container.classList.remove(modules_6381a4b3.light);
    container.classList.add(modules_59717246.dark);
    container.classList.add(GLOBAL_DARK_CLASS_NAME);
  } else {
    container.classList.remove(modules_59717246.dark);
    container.classList.remove(GLOBAL_DARK_CLASS_NAME);
    container.classList.add(modules_6381a4b3.light);
  }
}
var ThemeProvider = /*#__PURE__*/forwardRef(function ThemeProvider(_ref2, ref) {
  var _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? Theme.AUTO : _ref2$theme,
    className = _ref2.className,
    passToPopups = _ref2.passToPopups,
    _children = _ref2.children,
    target = _ref2.target,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var systemTheme = useTheme();
  var resolvedTheme = theme === Theme.AUTO ? systemTheme : theme;
  var id = useMemo(function () {
    return getUID('popups-with-theme-');
  }, []);
  var themeValue = useMemo(function () {
    return {
      theme: resolvedTheme
    };
  }, [resolvedTheme]);
  useEffect(function () {
    if (target != null) {
      applyTheme(resolvedTheme, target);
    }
  }, [resolvedTheme, target]);
  var themeClasses = useThemeClasses(theme);
  var parentTarget = useContext(PopupTargetContext);
  return /*#__PURE__*/jsx(ThemeContext.Provider, {
    value: themeValue,
    children: /*#__PURE__*/jsx("div", _objectSpread2(_objectSpread2({
      ref: ref,
      className: target != null ? undefined : classNames(className, themeClasses)
    }, restProps), {}, {
      children: passToPopups ? /*#__PURE__*/jsx(PopupTarget, {
        id: id,
        children: function children(popupTarget) {
          return /*#__PURE__*/jsxs(Fragment, {
            children: [_children, /*#__PURE__*/createPortal( /*#__PURE__*/jsx("div", {
              className: themeClasses,
              children: popupTarget
            }), parentTarget && getPopupContainer(parentTarget) || document.body)]
          });
        }
      }) : _children
    }))
  });
});
var Theme$1 = Theme;

export { GLOBAL_DARK_CLASS_NAME as G, Theme$1 as T, WithThemeClasses as W, ThemeProvider as a, ThemeContext as b, useThemeClasses as c, applyTheme as d, modules_59717246 as m, useTheme as u };
